<template>
    <v-dialog v-model="shows" max-width="1000px">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }">
            <v-card-title class="subtitle-1" primary-title>
                API 테스트 주문
                <v-spacer />
                <v-btn absolute right text icon @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <giftcard-cp-price-dialog-info v-bind="{ value: selectedGiftcard }" />
                <v-divider></v-divider>
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-card-subtitle>요청 정보</v-card-subtitle>
                        <v-row no-gutters>
                            <v-col cols="6" class="pa-2">
                                <v-select v-model="form.platform" :items="platforms" label="platform" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-select
                                    v-model="selectedGiftcard"
                                    :items="giftcards.filter((giftcard) => giftcard.platform == form.platform)"
                                    :item-text="({ name, cpamt }) => `${name} (${cpamt.format()})원`"
                                    return-object
                                    label="giftcard"
                                    @change="
                                        () => {
                                            form._giftcard = selectedGiftcard._id;
                                        }
                                    "
                                />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.orderNo" disabled label="주문번호" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-select v-model="form._cp" :items="cps" label="CP" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.quantity" type="number" label="구매수량" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.sender.name" label="발신자 성함" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.sender.phone" label="발신자 연락처" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.sender.email" label="발신자 이메일" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.receiver.name" label="수신자 성함" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.receiver.phone" label="수신자 연락처" />
                            </v-col>
                            <v-col cols="4" class="px-2">
                                <v-text-field v-model="form.receiver.email" label="수신자 이메일" />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-card-subtitle>요청 응답</v-card-subtitle>
                        <v-row no-gutters>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.cp.name" label="CP명" readonly />
                            </v-col>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.cp.remainCash" label="주문 후 CP 캐시" readonly />
                            </v-col>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.giftcard.name" label="상품권명" readonly />
                            </v-col>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.giftcard.remainStock" label="주문 후 재고" readonly />
                            </v-col>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.order.orderNo" label="주문번호" readonly />
                            </v-col>
                            <v-col cols="6" class="px-2">
                                <v-text-field v-model="result.order.orderedAt" label="주문 일자" readonly />
                            </v-col>
                            <v-col cols="3" class="px-2">
                                <v-text-field v-model="result.order.cpamt" label="API 가격" readonly />
                            </v-col>
                            <v-col cols="3" class="px-2">
                                <v-text-field v-model="result.order.discountRate" label="API 할인율" readonly />
                            </v-col>
                            <v-col cols="3" class="px-2">
                                <v-text-field v-model="result.order.quantity" label="개수" readonly />
                            </v-col>
                            <v-col cols="3" class="px-2">
                                <v-text-field v-model="result.order.salesAmount" label="주문 총 가격" readonly />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" dark text @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" dark @click="order">주문</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import GiftcardCpPriceDialogInfo from "../giftcards/giftcard-cp-price-dialog-info.vue";
const initForm = (form = {}) => ({
    ...form,
    _cp: form?._cp || null,
    _giftcard: form?.giftcard || null,
    quantity: form?.quantity || 0,
    orderNo: form?.orderNo || "test-api-order",
    platform: form?.platform || "",
    mode: "api",
    sender: form?.sender || {
        name: form?.sender?.name || "",
        phone: form?.sender?.phone || "",
        email: form?.sender?.email || "",
    },
    receiver: form?.receiver || {
        name: form?.receiver?.name || "",
        phone: form?.receiver?.phone || "",
        email: form?.receiver?.email || "",
    },
});
export default {
    components: {
        GiftcardCpPriceDialogInfo,
    },
    props: {
        cps: { type: Array, default: () => [] },
    },
    data() {
        return {
            loading: false,
            shows: false,

            form: initForm(),
            selectedGiftcard: {},
            giftcards: [],
            platforms: [],

            result: {
                cp: { name: "", remainCash: 0 },
                giftcard: { name: "", remainStock: 0 },
                order: { orderNo: "", cpamt: 0, quantity: 0, salesAmount: 0, orderedAt: "" },
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            this.loading = true;
            try {
                const { giftcards } = await api.console.shop.giftcards.gets({
                    headers: { skip: 0, limit: 0 },
                    params: { isApi: true },
                });

                this.giftcards = giftcards;
                this.platforms = giftcards.reduce((platforms, giftcard) => {
                    return 0 < platforms.indexOf(giftcard.platform) ? platforms : [...platforms, giftcard.platform];
                }, []);
            } catch (error) {
                console.error(error);
                alert(error.message);
            } finally {
                this.loading = false;
            }
        },
        async order() {
            if (this.loading) return;
            this.loading = true;
            try {
                if (!this.validates()) return;
                let { cp, giftcard, order } = await api.console.shop.orders.testApiPost(this.form);
                this.result = { cp, giftcard, order };
            } catch (error) {
                console.error(error);
                // alert(error.message);
            } finally {
                this.loading = false;
            }
        },
        validates() {
            let { _cp, sender, receiver, quantity, _giftcard } = this.form;
            if (!_cp) throw new Error("CP를 선택해주세요");
            if (!_giftcard) throw new Error("상품권를 선택해주세요");
            if (quantity <= 0) throw new Error("1개 이상의 수량을 입력해주세요");

            if (!sender.name) throw new Error("발신자 성함을 입력해주세요.");
            if (!sender.phone) throw new Error("발신자 연락처를 입력해주세요.");
            if (!sender.email) throw new Error("발신자 이메일을 입력해주세요.");

            if (!receiver.name) throw new Error("수신자 성함을 입력해주세요.");
            if (!receiver.phone) throw new Error("수자 연락처를 입력해주세요.");
            if (!receiver.email) throw new Error("수신 이메일을 입력해주세요.");
            return true;
        },
    },
};
</script>

<style>
</style>